module.exports = __webpack_public_path__ + "img/Aren-Wells.4022f0ad.png";